import { useFetch } from 'common.ui';
import { DependencyList } from 'react';
import { organizationGroupsClient } from 'api/AdgangClients';
import { OrganizationResponse } from 'api/adgang';

export function useOrganizations(
  organizationGroupIds: Array<number | undefined>,
  dependencies: DependencyList = [] as DependencyList
): [OrganizationResponse[] | undefined] {
  const fetchAllOrganizations = async (): Promise<OrganizationResponse[] | undefined> => {
    if (organizationGroupIds?.length === 0 || organizationGroupIds.includes(undefined)) return undefined;
    const result = await organizationGroupsClient.apiOrganizationGroupsOrganizationsGet({
      pageNumber: 1,
      pageSize: 9999,
      organizationGroupIds: organizationGroupIds as number[]
    });
    return result.data || undefined;
  };

  const [fetchedOrganizations] = useFetch<OrganizationResponse[] | undefined>(
    () => fetchAllOrganizations(),
    undefined,
    false,
    [...dependencies]
  );

  return [fetchedOrganizations];
}
